const PIECE_VALUES = {
  pawn: 100,
  knight: 320,
  bishop: 330,
  rook: 500,
  queen: 900,
  king: 0,
};

const centerDistance = (row, col) => Math.abs(4.5 - row) + Math.abs(4.5 - col);

export const evaluatePosition = (gameState) => {
  if (gameState.status.type === 'checkmate' || gameState.status.type === 'timeout') {
    const whiteWins = gameState.status.winner === 'white';
    return {
      centipawns: whiteWins ? 100000 : -100000,
      pawns: whiteWins ? 100 : -100,
      whitePercent: whiteWins ? 100 : 0,
      label: whiteWins ? 'White wins' : 'Black wins',
      decisive: true,
    };
  }
  if (['stalemate', 'draw'].includes(gameState.status.type)) {
    return { centipawns: 0, pawns: 0, whitePercent: 50, label: 'Drawn position', decisive: true };
  }

  let score = 0;
  const bishops = { white: 0, black: 0 };
  const mobility = { white: 0, black: 0 };

  for (let row = 1; row <= 8; row += 1) {
    for (let col = 1; col <= 8; col += 1) {
      const piece = gameState.board[row][col];
      if (!piece) continue;
      const direction = piece.color === 'white' ? 1 : -1;
      let positional = 0;
      if (piece.type === 'pawn') positional += piece.color === 'white' ? (7 - row) * 7 : (row - 2) * 7;
      if (['knight', 'bishop', 'queen'].includes(piece.type)) positional += Math.max(0, 12 - centerDistance(row, col) * 3);
      if (piece.type === 'bishop') bishops[piece.color] += 1;
      score += direction * (PIECE_VALUES[piece.type] + positional);
      mobility[piece.color] += gameState.getLegalMoves([row, col]).length;
    }
  }

  if (bishops.white >= 2) score += 25;
  if (bishops.black >= 2) score -= 25;
  score += (mobility.white - mobility.black) * 2;
  if (gameState.isInCheck('white')) score -= 35;
  if (gameState.isInCheck('black')) score += 35;

  const centipawns = Math.round(score);
  const pawns = Math.round((centipawns / 100) * 10) / 10;
  const whitePercent = Math.round((50 + 50 * Math.tanh(pawns / 4)) * 10) / 10;
  const magnitude = Math.abs(pawns);
  let label = 'Position is equal';
  if (magnitude >= 5) label = `${pawns > 0 ? 'White' : 'Black'} is winning`;
  else if (magnitude >= 1.2) label = `${pawns > 0 ? 'White' : 'Black'} is better`;
  else if (magnitude >= 0.4) label = `Slight edge for ${pawns > 0 ? 'White' : 'Black'}`;

  return { centipawns, pawns, whitePercent, label, decisive: false };
};
